<style type="text/css" media="screen">

.return-box{
	border: 2px solid #6D7C8E;
	box-sizing: border-box;
	border-radius: 20px;
	width:175px;
}
.balance-box{
	border: 2px solid #1DC895;
	box-sizing: border-box;
	border-radius: 20px;
	min-width: 366px;
}
.btn-block{
	min-width: 60%
}
</style>
<template>
	<div>
		<!-- return card -->
		<div class="d-inline-block return-box pa-4 cursor-pointer"   
		@click="gotoReturnsList">
		<p class="secodry-text-2 fs-14">{{$lang.TOTAL_RETURNS}}</p>
		<p class="secodry-text-2 fw-800 fs-36">{{return_count}}</p>
	</div>
	<!--  withdraw card -->
	<div class="d-inline-block balance-box pa-4 ml-8 " >
		<div class="d-inline-block cursor-pointer btn-block" 
		@click="gotoCollectionList">
		<p class="secodry-text-2  fs-14">{{$lang.CURRENT_BALANCE}}</p>
		<img src="../../../assets/rupee.svg" alt="" width="20">
		<span class="sub-title-text fs-36">
			{{current_balance}}
		</span>
	</div>
	<div class="d-inline-block v-align-top mt-4 pl-4 text-right " >
		<v-btn color="primary "
		@click="withdraw" >
		<b>{{$lang.WITHDRAW}}</b>
	</v-btn>
</div>
</div>


</div>
</template>
<script>
export default{
	props:['current_balance','return_count'],
	methods:{
		gotoReturnsList(){
			if (this.return_count>0)
				this.$router.push({name:'returns',query:{type:this.encript(this.$keys.RETURNS)}})
		},
		gotoCollectionList(){
			if (this.current_balance>0)
				this.$router.push({name:'collections',query:{type:this.encript(this.$keys.COLLECTION)}})
		},
		withdraw(){
			if(this.return_count>0||  this.current_balance>0)
				this.$emit("initiate-withdrawal")
			else
				this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:"Nothing to withdraw", color:"warning" })
		}
	}
}	
</script>